import { Routes, Route } from "react-router-dom";
import AppointmentSelect from "./components/home/AppointmentSelect";
import ScrollToTop from "./utility/ScrollToTop";
import AppointmentSuccess from "./page/Appointmentsuccess";
import Footer from "./components/Footer";
import AppoinmentBook from "./page/AppoinmentBook/AppoinmentBook";
import ThankYou from "./page/ThankYou";
import AppointmentForm from "./page/appoinment-form/AppointmentForm";

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <header className="sticky-header">
          <a href="https://asianheartinstitute.org/">
            <img src="/logo.webp" alt="Asian Heart Logo" className="logo" />
          </a>
        </header>

        {/* This div grows to fill space between header and footer */}
        <div className="flex-1 flex flex-col">
          <Routes>
            <Route path="/" element={<AppointmentSelect />} />
            {/* <Route
              path="/appointment-success"
              element={<AppointmentSuccess />}
            /> */}
            <Route path="/appointment-detail" element={<AppoinmentBook />} />
            <Route path="/book-an-appointment" element={<AppointmentForm />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route
              path="/appointment-success"
              element={<AppointmentSuccess />}
            />
          </Routes>
        </div>

        <Footer />
      </div>
      {/* <header className="sticky-header">
        <a href="https://asianheartinstitute.org/">
          <img src="/logo.webp" alt="Asian Heart Logo" className="logo" />
        </a>
      </header>

      <Routes>
        <Route path="/" element={<AppointmentSelect />} />

        <Route path="/appointment-success" element={<AppointmentSuccess />} />

        <Route path="/appointment-detail" element={<AppoinmentBook />} />
        <Route path="/book-an-appointment" element={<AppointmentForm />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
      <Footer /> */}
    </>
  );
}

export default App;
